import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "@firebase/firestore"

import { loadStripe } from "@stripe/stripe-js"

import { getFunctions, httpsCallable } from "firebase/functions"

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBAE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)

const db = getFirestore(app)

const auth = getAuth(app)

// Initialize Stripe with your publishable key (outside the function to avoid reinitialization)
// const stripePromise = loadStripe(
//   "pk_test_51PtqMxALsC4xMTfLLDG7KjvMXXVLB4PpBZPzdHsVSXni4vNRsgEgi9yyN9yhNfBlDxaHT73T3NHNg17YZcknhUqd00kcm4RPHs"
// );

const stripePromise = loadStripe(
  "pk_live_51PtqMxALsC4xMTfL9I26PtOAhTb7Z4MbcdpgEfdGCBAVLB4q4oDGGcrHkwL8ZA68WexPYNOjQ6fmpaj0SdHOtU6F00MMtFiEp1"
)
// const stripePromise = loadStripe(
//   process.env.REACT_APP_STRIPE_APP_PUBLISHABLE_KEY
// );

// Initialize instances of Firebase cloud functions
const functions = getFunctions()

const createStripeCheckout = httpsCallable(functions, "createStripeCheckout")

// const provider = new GoogleAuthProvider();

// export const signInWithGoogle = () => {
//   signInWithPopup(auth, provider)
//     .then((result) => {
//       const name = result.user.displayName;
//       const email = result.user.email;
//       const profilePic = result.user.photoURL;

//       localStorage.setItem("name", name);
//       localStorage.setItem("email", email);
//       localStorage.setItem("profilePic", profilePic);
//     })
//     .catch((error) => {
//       console.log(error);
//     });
// };
// export const signInWithGoogleOther = async () => {
//     try {
//         const authGoogle= await   signInWithPopup(auth, provider);
//         return  authGoogle;
//     } catch (e) {
//         return null;
//     }

// };

export { db, auth, stripePromise, createStripeCheckout }

// export default app
// connectFirestoreEmulator(db, "127.0.0.1", 8080) // all reads/writes go to the emulator
// connectAuthEmulator(auth, "http://127.0.0.1:9099") // use http://, not https
